import React, { FC } from 'react';
import { MenuMore, Skeleton } from '@dxb-web-ui-framework/design-system';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useTranslation } from 'react-i18next';
import { GetApp as DownloadTransactionDetailsIcon, PictureAsPdf } from '@dxb-web-ui-framework/design-system/dist/icons';
import { useDownloadTransactionDetails } from '../../../../../content-composer/src/hooks/useDownloadTransactionDetails';
import { usePrintSwiftConfirmation } from '../../../../../content-composer/src/hooks/usePrintSwiftConfirmation';
import { ECOMMBXLoader } from '../../../../../content-composer/src/components/Generic/ECOMMBXLoader/ECOMMBXLoader';
import { ConsolidatedTransactionDetails } from '../../../domain/Transaction/entities/ConsolidatedTransaction';

type TransactionDetailsDrawerFileProps = {
  isLoading: boolean;
  isAuthorization?: boolean;
  transactionDetails?: Nullable<ConsolidatedTransactionDetails>;
};

const TransactionDetailsDrawerFileDownload: FC<TransactionDetailsDrawerFileProps> = ({
  isLoading,
  isAuthorization,
  transactionDetails,
}) => {
  const { t } = useTranslation();
  // const { isExtraSmallScreen: isMobile } = useScreenDetector();
  const { isLoadingDownloadData, onDownloadDetails } = useDownloadTransactionDetails();
  const { isLoadingSwiftConfirmationDownloadData, onDownloadSwiftConfirmationDetails } = usePrintSwiftConfirmation();

  const isSwiftDetailsDownloadEnabled =
    transactionDetails && transactionDetails.orderProcessType === 'SWIFT' && transactionDetails.status === '3';

  const accountNumber =
    transactionDetails?.type === 'O' ? transactionDetails?.fromAccount : transactionDetails?.toAccount;

  const items = [
    {
      disabled: isLoadingDownloadData,
      icon: !isLoadingDownloadData ? <PictureAsPdf /> : <ECOMMBXLoader size='small' />,
      label: isAuthorization
        ? t('transactionDetailsDrawer.actions.isAuthorizedBtn.Title')
        : t('transactionDetailsDrawer.actions.isNotAuthorizedBtn.Title'),
      onClick: () =>
        transactionDetails && onDownloadDetails(String(transactionDetails.orderId), accountNumber as string),
    },
  ];

  if (transactionDetails?.type === 'O') {
    items.push({
      disabled: !isSwiftDetailsDownloadEnabled || isLoadingSwiftConfirmationDownloadData,
      icon: !isLoadingSwiftConfirmationDownloadData ? <PictureAsPdf /> : <ECOMMBXLoader size='small' />,
      label: t('TransactionDetailsDrawerFileDownload.SwiftDetails'),
      onClick: () =>
        transactionDetails &&
        onDownloadSwiftConfirmationDetails(String(transactionDetails.orderId), accountNumber as string),
    });
  }

  return (
    <>
      {isLoading && <Skeleton width='36px' height='36px'></Skeleton>}
      {!isLoading && (
        <MenuMore
          menuTitle={t('FileDownload.ExportOptions')}
          menuMoreAriaLabel={t('FileDownload.ExportOptions')}
          drawerTitle={t('FileDownload.ExportOptions')}
          icon={<DownloadTransactionDetailsIcon color='secondary' />}
          items={items}
        />
      )}
    </>
  );
};
export { TransactionDetailsDrawerFileDownload };
